const $ = require('jquery')
const Vue = require('vue')

const template = require('templates/geo-location-picker.html')

const buildAddress = (search) => {
    const cityName = search.city ? search.city.name : ''
    const stateName = search.state ? search.state.name : ''

    let text = search.street
    if (search.street_number) {
        text += `, ${search.street_number}`
    }
    return `${text} - ${cityName} - ${stateName}`
}

const buildAlert = (search) => {
    return `
        <div class="alert alert-warning" style="margin: 0px;border-radius: 0px;border: none;">
            <i class="fa fa-info"></i>
            Nenhum endereço encontrado 
             ${buildAddress(search)}
        </div>
    `
}

const loadMap = (element, input, defaultPosition, search, changed) => {
    const google = window.google
    const $el = $(element)

    const position = {
        lat: defaultPosition.lat || -23.5505199,
        lng: defaultPosition.lng || -46.63330940000003
    }

    const map = new google.maps.Map(element, {
        center: position,
        zoom: 13
    })

    const marker = new google.maps.Marker({
        position: position,
        draggable: true,
        animation: google.maps.Animation.DROP,
        map
    })

    marker.addListener('dragend', function (event) {
        changed({
            latitude: event.latLng.lat(),
            longitude: event.latLng.lng()
        })
    })

    const searchBox = new google.maps.places.SearchBox(input)

    searchBox.addListener('places_changed', function () {
        var place = searchBox.getPlaces()[0]

        map.setCenter(place.geometry.location)
        map.setZoom(13)
        marker.setPosition({
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng()
        })

        changed({
            latitude: place.geometry.location.lat(),
            longitude: place.geometry.location.lng()
        })
    })

    map.addListener('click', function (event) {
        marker.setPosition(event.latLng)

        changed({
            latitude: event.latLng.lat(),
            longitude: event.latLng.lng()
        })
    })

    const searchApi = new google.maps.places.PlacesService(map)

    if (!defaultPosition.lat) {
        searchApi.textSearch({
            query: buildAddress(search)
        }, (r) => {
            const location = r.shift()
            if (location) {
                const latLng = location.geometry.location

                map.setCenter(latLng)
                map.setZoom(13)
                marker.setPosition(latLng)

                const circle = new google.maps.Circle({
                    strokeColor: '#FFFFFF',
                    strokeOpacity: 0.3,
                    strokeWeight: 2,
                    fillColor: '#FFFFFF',
                    fillOpacity: 0.35,
                    map: map,
                    center: latLng,
                    radius: 1000
                })

                circle.addListener('click', function (event) {
                    circle.setMap(null)
                })

                changed({
                    latitude: latLng.lat(),
                    longitude: latLng.lng()
                })
            } else {
                $el.parent().prepend(buildAlert(search))
            }
        })
    } else {
        searchApi.textSearch({
            query: buildAddress(search)
        }, (r) => {
            const location = r.shift()
            if (location) {
                const latLng = location.geometry.location

                const circle = new google.maps.Circle({
                    strokeColor: '#FFFFFF',
                    strokeOpacity: 0.3,
                    strokeWeight: 2,
                    fillColor: '#FFFFFF',
                    fillOpacity: 0.35,
                    map: map,
                    center: latLng,
                    radius: 1000
                })

                circle.addListener('click', function (event) {
                    circle.setMap(null)
                })
            } else {
                $el.parent().prepend(buildAlert(search))
            }
        })
    }

    // map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);
}
// '<button class="btn blue btn-block" style="margin-top:23px;"><slot></slot></button>'
Vue.component('geo-location-picker', {
    template: template,

    props: {
        'on-location-pick': null,
        'latitude': null,
        'longitude': null,
        'search': null
    },

    data () {
        return {
            loaded: false,
            shown: false,
            defaultPosition: {
                latitude: null,
                longitude: null
            }
        }
    },

    watch: {
        latitude (newVal) {
            this.defaultPosition.latitude = newVal
        },
        longitude (newVal) {
            this.defaultPosition.longitude = newVal
        },
        'search': {
            deep: true,
            handler: function (newVal) {
                if (!this.loaded) {
                    return
                }

                const $el = $(this.$el)
                if (newVal.street && newVal.city && newVal.state) {
                    $el.prop('disabled', false)
                } else {
                    $el.prop('disabled', true)
                }
            }
        }
    },

    methods: {
        confirmLocation () {
            if (this.onLocationPick) {
                this.onLocationPick(this.defaultPosition)
            }

            this.$refs.modalGeoLocation.hide()
        }
    },

    ready () {
        const self = this
        const $el = $(this.$el)

        this.defaultPosition = {
            lat: this.latitude,
            lng: this.longitude
        }

        $el.prop('disabled', true)

        const checkInterval = setInterval(() => {
            if (window.google && window.google.maps) {
                this.loaded = true
                if (this.search.street && this.search.city && this.search.state) {
                    $el.prop('disabled', false)
                } else {
                    $el.prop('disabled', true)
                }
                clearInterval(checkInterval)
            }
        }, 500)

        $el.on('click', function () {
            if ($el.prop('disabled')) {
                window.alert('Carregando...')
                return false
            }

            self.$refs.modalGeoLocation.show()

            if (self.shown) {
                return
            }

            const element = $(self.$refs.modalGeoLocation.$el).find('.map-element').get(0)
            const searchElement = $(self.$refs.modalGeoLocation.$el).find('.map-search').get(0)

            loadMap(element, searchElement, self.defaultPosition, self.search, (position) => {
                self.defaultPosition = {
                    latitude: position.latitude,
                    longitude: position.longitude
                }

                if (self.onLocationPick) {
                    self.onLocationPick(self.defaultPosition)
                }
            })
            self.shown = true
            /*
            let $modal = modal({
                title: `<i class="fa fa-map-marker modal-icon"></i> Aponte o local`,
                body: template,
                primaryButton: `Ok`,
                secondaryButton: null,
                width: 800,
                //onPrimaryButton: sendForm(it),
                onShown: function ($modal) {
                    let element = $modal.find('.map-element').get(0);
                    let searchElement = $modal.find('.map-search').get(0);

                    $modal.find('.modal-body').css('padding', 0);

                }
            });
            */
        })
    },
    update (value) {
    },
    unbind () {
    }
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/geolocation-picker.js